import { createApi } from '@reduxjs/toolkit/query/react';

export const createCustomApi: typeof createApi = options => {
	return createApi({
		...options,
		keepUnusedDataFor: 600000,
	});
};
